import { useEffect, useState, useContext, useRef } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'
import { getGoodsCouponList } from './api'
import imgResize from '@/utils/img-resize'
import { isDuApp } from '@/utils/appUtils/getDevice'
import appInstall from '@/utils/appUtils/appInstall'
import Jockeys from '@/utils/jockey'
import { EditConfigType } from '@/typings/types'
import Conetext from '../context'

import { SpuType } from '../index'

import { createTrackConfig } from '../trackConfig'
import { useWithReactFunctionalTrack } from '@du/analytics-sdk'
import { IUserType } from '@/components/poizon-new-user-coupon-v3/typing'
import { getGoodList } from '@/apis/share'
import { formatMoney } from '@/utils'

interface IProps {
  type: SpuType
  list: string[]
  editConfig: EditConfigType
  index: number
  renderUserType: IUserType
}

const goDetail = (item) => {
  if (isDuApp()) {
    Jockeys.openNativePage('/sell/productDetail', {
      spuId: item.spuId,
    })
    return
  }
  appInstall('/sell/productDetail', {
    spuId: item.spuId,
  })
}

export default function List(props: IProps) {
  // 埋点绑定
  const functionalProps = { ...props }

  // 使用hook useEffect api ，当ref有值则组件渲染结束，props可挂载并执行$track函数
  const functionalRef = useRef(null)
  useWithReactFunctionalTrack({
    functionalRef,
    functionalProps,
    useEffect,
    createTrackConfig,
  })

  const { type, list, renderUserType } = props
  const { lang, local } = props.editConfig
  const [data, setData] = useState([])

  const { langConfig, currencyCode } = useContext(Conetext)
  useEffect(() => {
    const key = type === SpuType.SPUID ? 'spuIdInfo' : 'itemInfo'
    const spuIds = list.map((spuId, index) => {
      const key = type === SpuType.SPUID ? 'spuId' : 'itemNum'
      return { [key]: `${spuId}`.trim(), index }
    })
    if (renderUserType === IUserType.buyer) {
      getGoodsCouponList({
        [key]: JSON.stringify(spuIds),
        countryCode: local,
        language: lang,
      }).then(({ status, data = [] }) => {
        if (status === 200) {
          setData(data)
        }
      })
    } else {
      getGoodList({
        [key]: JSON.stringify(spuIds),
        countryCode: local,
        language: lang,
      }).then(({ status, data = [] }) => {
        if (status === 200) {
          setData(data.spuDTOList)
        }
      })
    }
  }, [])

  return (
    <div
      className={classnames({
        [styles['list']]: true,
        [`product-view-box-list-${props.index}`]: true,
      })}
      ref={functionalRef}
    >
      {data.map((v, index) => {
        return (
          <div
            className={styles['item']}
            key={index}
            onClick={() => {
              goDetail(v)
            }}
            data-track-click="poizon_common_product_list_click"
            data-track-exposure="poizon_mail_block_exposure"
            data-id={v.spuId}
            data-1={v.originalPrice}
            data-2={v.price}
            data-title={v.title}
          >
            <img
              className={styles['cover']}
              data-layzload-src={imgResize(v.cover || v.logoUrl, 0, 160)}
              alt=""
            />
            <div className={styles['title']}>{v.title}</div>
            {renderUserType === IUserType.buyer && !!v.price ? (
              <div className={styles['label-box']}>
                <div className={styles['label']}>{langConfig.discount}</div>
              </div>
            ) : (
              <div className={styles['label-box']}></div>
            )}
            <div className={styles['info']}>
              <div
                className={classnames({
                  [styles['now-price']]: true,
                  [styles['discount']]: !!v.price,
                })}
              >
                {currencyCode} {formatMoney(v.price || v.originalPrice)}
              </div>
              {!!v.price && !!v.originalPrice && (
                <del className={styles['original-price']}>
                  {currencyCode} {formatMoney(v.originalPrice)}
                </del>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
